/**
 * Makes the native Shopify availability filter the default for collection pages.
 *
 * Applying the filter in the URL lets Shopify calculate the grid, product count,
 * pagination, sorting, and infinite-scroll responses from available products only.
 */
const url = new URL(window.location.href);
const availabilityValues = url.searchParams.getAll('filter.v.availability');

if (availabilityValues.length !== 1 || availabilityValues[0] !== '1') {
  url.searchParams.delete('filter.v.availability');
  url.searchParams.set('filter.v.availability', '1');
  url.searchParams.delete('page');

  window.location.replace(url);
}
